import React from "react";
export function SiteFooter() {
  return <footer className="bg-ink px-5 pb-32 pt-12 text-center" data-id="element-255" data-mp="3rjw0bkxgv4kv">
      <p className="font-display text-2xl font-bold text-white" data-id="element-256" data-mp="1bealjg3whyj5">Endo Blueprint™</p>
      <p className="mt-2 text-[15px] text-white/75" data-id="element-257" data-mp="1fg5m2ie0c7vv">
        Organize your knowledge. Connect the concepts. Structure your case review.
      </p>
      <p className="mt-1 text-sm text-white/60" data-id="element-258" data-mp="1kf8ixfju37sr">Created by Dr. Nathan Brooks.</p>
      <p className="mx-auto mt-6 max-w-2xl text-xs leading-relaxed text-white/55" data-id="element-259" data-mp="nqsph8dlsead">
        Educational resource only. This product does not replace formal training, current scientific evidence, specialist
        consultation, or patient-specific clinical judgment.
      </p>
      <p className="mt-4 text-xs text-white/55" data-id="element-260" data-mp="11hfqj76u6g9m">© 2026 · Endo Blueprint™ · All rights reserved.</p>
    </footer>;
}